import React from 'react';
import {CommonCreate} from '../Common';
import {getInputs} from './Common';

export const MaterialTCO2Create = props => (
  <CommonCreate
    {...{
      ...props,
      fields: getInputs(),
    }}
  />
);
